import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Button, Space } from "antd";
import { MenuOutlined, GlobalOutlined, LogoutOutlined, UserOutlined, EditOutlined, LockOutlined } from "@ant-design/icons";
import { sanecka } from "../assets/assets"; // Replace with the correct path
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import "./Navigation.css"; // Add your styles here
import FooterComponent from "../footer/Footer";
import FloatingButtons from "../common/FloatingButtons";
import { logoutUser } from "../../actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";

const LoggedInNavigation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [selectedKey, setSelectedKey] = useState("");
    const [currentLanguage, setCurrentLanguage] = useState("English");

    const user = useSelector(state => state.user.user);

    const menuItems = [
        { label: "Dashboard", key: "dashboard", route: "/dashboard" },
        { label: "Artists", key: "artists", route: "/artists" },
        { label: "Requests", key: "requests", route: "/requests" },
        { label: "Visits", key: "visits", route: "/visits" },
    ];

    // Update selectedKey based on the current route
    useEffect(() => {
        const currentItem = menuItems.find((item) => item.route === location.pathname);
        if (currentItem) {
            setSelectedKey(currentItem.key);
        } else {
            setSelectedKey("");
        }
    }, [location]);

    // Handle menu item click and navigation
    const handleMenuClick = (e) => {
        const clickedItem = menuItems.find((item) => item.key === e.key);
        if (clickedItem) {
            navigate(clickedItem.route);
        }
    };

    // Handle language change
    const handleLanguageChange = (language) => {
        setCurrentLanguage(language);
        // Logic for changing language
    };

    // Handle logout
    const handleLogout = () => {
        dispatch(logoutUser());
    }

    const languageMenu = (
        <Menu>
            <Menu.Item onClick={() => handleLanguageChange("English")}>English</Menu.Item>
            <Menu.Item onClick={() => handleLanguageChange("Swahili")}>Swahili</Menu.Item>
        </Menu>
    );

    const userMenu = (
        <Menu>
            <Menu.Item icon={<UserOutlined />} disabled>
                {user?.names || "User"}
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3" icon={<EditOutlined />}>
                <Link to="/user">My Profile</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<LockOutlined />}>
                <Link to="/change-password">Change Password</Link>
            </Menu.Item>
            <Menu.Item style={{ color: 'red' }} icon={<LogoutOutlined />} onClick={handleLogout}>
                Logout
            </Menu.Item>
        </Menu>
    );

    return (
        <div >
            <div className="navigation">
                <div className="navigation-left">
                    <img
                        src={sanecka}
                        alt="Sanecka Logo"
                        className="navigation-logo"
                        onClick={() => navigate("/")}
                        style={{ cursor: "pointer" }}
                    />
                    <Menu
                        mode="horizontal"
                        items={menuItems}
                        disabledOverflow={true}
                        className="navigation-menu"
                        onClick={(e) => handleMenuClick(e)}
                        selectedKeys={[selectedKey]} // Sync selected key with route
                    />
                </div>
                <div className="navigation-right user-big-screen">
                    <Space size="middle">
                        {/* <Dropdown overlay={languageMenu} placement="bottomRight">
                        <Button icon={<GlobalOutlined />}>{currentLanguage}</Button>
                    </Dropdown> */}
                        <Dropdown overlay={userMenu} placement="bottomRight">
                            <Button>{"Profile" || "User"}</Button>
                        </Dropdown>
                    </Space>
                </div>
                <div className="navigation-mobile">
                    <Dropdown
                        overlay={
                            <Menu>
                                 <Menu.Item icon={<UserOutlined />} disabled>
                {user?.names || "User"}
            </Menu.Item>
            <Menu.Divider />
         
                                {menuItems.map((item) => (
                                    <Menu.Item
                                        key={item.key}
                                        onClick={() => navigate(item.route)}
                                    >
                                        {item.label}
                                    </Menu.Item>
                                ))}
                                <Menu.Divider />
                                <Menu.Item key="3" icon={<EditOutlined />}>
                <Link to="/user">My Profile</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<LockOutlined />}>
                <Link to="/change-password">Change Password</Link>
            </Menu.Item>
                                <Menu.Item style={{color:'red'}} onClick={handleLogout}>
                                    <LogoutOutlined /> Logout
                                </Menu.Item>
                            </Menu>
                        }
                        trigger={["click"]}
                    >
                        <Button icon={<MenuOutlined />} />
                    </Dropdown>
                </div>
            </div>
            <div>
                <Outlet /> {/* Render child routes */}
            </div>
            <FloatingButtons />
            <FooterComponent />

        </div>
    );
};

export default LoggedInNavigation;
